export default __webpack_public_path__ + "static/media/what-img.e8ac3fce.png";